<div class="page availability-page">
  <div class="header availability-header">
    <h1 class="header-title">
      <button
        class="schedule-back"
        mat-icon-button
        aria-label="Terug"
        (click)="this.location.back()"
        style="color: inherit"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>
      <mat-icon>event_available</mat-icon>
      <span>Personeelsbeschikbaarheid</span>
    </h1>
  </div>

  <mat-card class="content overview-content">
    <div class="overview-toolbar">
      <div class="legend" aria-label="Legenda">
        <div class="legend-group" aria-label="Beschikbaarheidslegenda">
          <span><i class="legend-swatch state-available"></i> Beschikbaar</span>
          <span><i class="legend-swatch state-scheduled"></i> Ingepland</span>
          <span><i class="legend-swatch state-exception"></i> Uitzondering</span>
          <span><i class="legend-swatch state-unavailable"></i> Niet beschikbaar</span>
        </div>
        <div class="legend-group" aria-label="Rollenlegenda">
          <span><strong>C</strong> Chauffeur</span>
          @if (coDriverEnabled()) {
            <span><strong>B</strong> Bijrijder</span>
          }
          @if (usesPlannerPlanning()) {
            <span><strong>P</strong> Planner</span>
          }
        </div>
      </div>
      <div class="week-controls" aria-label="Week navigatie">
        <button
          class="week-navigation-button"
          mat-icon-button
          aria-label="Vorige week"
          (click)="changeWeek('previous')"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button
          class="week-navigation-button"
          mat-icon-button
          aria-label="Deze week"
          matTooltip="Deze week"
          (click)="goToCurrentWeek()"
        >
          <mat-icon>today</mat-icon>
        </button>
        <button
          mat-flat-button
          class="week-label week-label-button"
          aria-label="Week selecteren"
          (click)="weekDatepicker.open()"
        >
          {{ weekLabel() }}
          <mat-form-field class="week-date-picker">
            <mat-datepicker #weekDatepicker disabled="false">
              <input
                matInput
                [matDatepicker]="weekDatepicker"
                [ngModel]="selectedWeekStart()"
                (dateChange)="selectWeek($event.value)"
                disabled
              />
            </mat-datepicker>
          </mat-form-field>
        </button>
        <button class="week-navigation-button" mat-icon-button aria-label="Volgende week" (click)="changeWeek('next')">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
      <mat-form-field class="search-field mat-form-field-no-subscript">
        <mat-label class="placeholder">Zoeken</mat-label>
        <input
          matInput
          placeholder="Zoeken"
          autocomplete="off"
          [value]="searchTerm()"
          (input)="setSearchTerm($any($event.target).value)"
        />
        <button
          mat-icon-button
          matSuffix
          aria-label="Zoekopdracht wissen"
          (click)="clearSearch(); $event.stopPropagation()"
        >
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <mat-tab-group
      [selectedIndex]="selectedIndex()"
      (selectedIndexChange)="setTab($event)"
      (animationDone)="onTabAnimationDone()"
    >
      <mat-tab [label]="coDriverEnabled() ? 'Chauffeurs en bijrijders' : 'Chauffeurs'">
        <ng-container *ngTemplateOutlet="overviewGrid"></ng-container>
      </mat-tab>
      @if (usesPlannerPlanning()) {
        <mat-tab label="Planners">
          <ng-container *ngTemplateOutlet="overviewGrid"></ng-container>
        </mat-tab>
      }
    </mat-tab-group>
  </mat-card>

  <ng-template #overviewGrid>
    @if (loading() || tabTransitioning()) {
      <div class="state-message" role="status" aria-label="Beschikbaarheid laden">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
    } @else if (error()) {
      <div class="state-message">De beschikbaarheid kon niet worden geladen.</div>
    } @else if (columns().length === 0) {
      <div class="state-message">Geen dagdelen gevonden voor deze planning.</div>
    } @else if (visibleRows().length === 0 && !searchTerm().trim()) {
      <div class="state-message">Geen personeel gevonden voor deze week.</div>
    } @else {
      <div class="grid-scroll" role="region" aria-label="Personeelsbeschikbaarheid">
        <div
          class="availability-grid"
          [class.fixed-column-widths]="columns().length >= 10"
          role="table"
          [style.--column-count]="columns().length"
        >
          <div #gridHeader class="grid-header-scroll">
            <div class="grid-header-row date-header-row" role="row">
              <div class="header-spacer header-spacer-top sticky-cell" aria-hidden="true"></div>
              @for (group of columnGroups(); track group.dateKey) {
                <div class="date-header" role="columnheader" [style.grid-column]="'span ' + group.columns.length">
                  {{ dayLabel(group.date) }}
                </div>
              }
            </div>
            <div class="grid-row grid-header daypart-header-row" role="row">
              <div
                class="header-spacer header-spacer-bottom sticky-cell"
                role="columnheader"
                aria-label="Personeel"
              ></div>
              @for (column of columns(); track column.key) {
                <div class="daypart-cell" role="columnheader">
                  <strong appOverflowTooltip tabindex="0" [matTooltip]="column.daypart.daypart.name ?? 'Dagdeel'">{{
                    column.daypart.daypart.name ?? 'Dagdeel'
                  }}</strong>
                  <span>{{ formatDaypartTime(column.daypart) }}</span>
                </div>
              }
            </div>
          </div>

          @if (assignmentRefreshing()) {
            <div class="assignment-refresh-state" role="status" aria-label="Beschikbaarheid laden">
              <mat-spinner diameter="32"></mat-spinner>
            </div>
          } @else {
            <cdk-virtual-scroll-viewport
              #rowsViewport
              itemSize="56"
              class="rows-viewport"
              [class.no-results]="visibleRows().length === 0"
              (scroll)="syncHeaderScroll(gridHeader, $event)"
            >
              <div *cdkVirtualFor="let row of visibleRows(); trackBy: trackRow" class="grid-row" role="row">
                <div class="name-cell sticky-cell" role="rowheader">
                  <span appOverflowTooltip class="user-name" tabindex="0" [matTooltip]="displayName(row.user)">{{
                    displayName(row.user)
                  }}</span>
                </div>
                @for (cell of row.cells; track $index) {
                  <div
                    class="availability-cell"
                    role="cell"
                    [class.state-available]="cell.state === 'available'"
                    [class.state-scheduled]="cell.state === 'scheduled'"
                    [class.state-exception]="cell.state === 'exception'"
                    [class.state-unavailable]="cell.state === 'unavailable'"
                    [attr.aria-label]="cell.ariaLabel"
                  >
                    {{ cell.indicator ?? '' }}
                  </div>
                }
              </div>
              @if (visibleRows().length === 0) {
                <div class="grid-row no-results-row" role="row">
                  <div class="state-message" role="cell">Geen personeel gevonden voor deze zoekopdracht.</div>
                </div>
              }
            </cdk-virtual-scroll-viewport>
          }
        </div>
      </div>
    }
  </ng-template>
</div>
